import { render, staticRenderFns } from "./ReLogin.vue?vue&type=template&id=9b0e9012&"
import script from "./ReLogin.vue?vue&type=script&lang=js&"
export * from "./ReLogin.vue?vue&type=script&lang=js&"
import style0 from "./ReLogin.vue?vue&type=style&index=0&id=9b0e9012&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports